import { frontendURL } from '../../../../helper/URLHelper';
import store from '../../../../store';
import CustomMenusView from './pages/CustomMenusView.vue';

const redirectIfNotSuperAdmin = (to, _from, next) => {
  const currentUser = store.getters.getCurrentUser;
  if (currentUser?.type === 'SuperAdmin') {
    next();
    return;
  }
  next({ name: 'home', params: { accountId: to.params.accountId } });
};

const customMenusSettingsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-menus'),
      name: 'custom_menus_settings_index',
      meta: {
        permissions: ['administrator'],
      },
      beforeEnter: redirectIfNotSuperAdmin,
      component: CustomMenusView,
    },
  ],
};

export default customMenusSettingsRoutes;
